export default "__VITE_ASSET__e4e36da5__"